if (!window.location.origin) {
    window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
}
//软件开发环境   dev：本地开发环境 prod：生产环境
let active  = process.env.NODE_ENV == 'production' ? 'prod' : 'dev' ;
// active = 'prod';
import conf from "./config.json";
import prod from "./prod.json";

let _config;
/*读取生产环境配置*/
if( active == 'prod' ){
    _config    = Object.assign( conf, prod );
}else
    _config     = conf;
const globalConf    = Object.assign( _config, process.env.appConf );
globalConf.active   = active;
window.config       = eval( globalConf );
